import FieldValidationError from "./FieldValidationError";

const InputNumeric = (props) => {
    const { error, className = "", onChange, onKeyDown, ...rest } = props;

    const handleKeyDown = (event) => {
        // Permite apenas números e teclas de controle (Backspace, setas, Delete, Tab)
        if (!/^[0-9]$/.test(event.key) && 
            !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(event.key)) {
            event.preventDefault();
        }

        onKeyDown && onKeyDown(event);
    };

    const handleChange = (event) => {
        // Remove caracteres não numéricos e impede valores negativos
        const value = event.target.value.replace(/\D/g, ''); // Mantém apenas números
        onChange && onChange({ target: { name: rest.name, value } });
    };

    return (
        <>
            <input
                type="text"
                className={`form-control ${className}`.trim()}
                {...rest}
                onKeyDown={handleKeyDown} 
                onChange={handleChange}
                inputMode="numeric" // Garante teclado numérico em mobile
                pattern="\d*" // Sugere entrada apenas numérica
            />
            <FieldValidationError error={error} />
        </>
    );
};

export default InputNumeric;
